import {
  EnumCreditSwapStatus,
  EnumCreditSwapStep,
  EnumSwapType
} from '@wallet-manager/pfh-pmp-node-def-types/dist/src/DbModel/SwapAgent';

import { IdateFilter, Ipage } from '../../../../api/types';
import { useListMappingTransform, useTranslation } from '../../../../hooks';
import { amountDivideDecimals, displayAmountCurrying, toDisplayTime } from '../../../../utils';
import { initZusParams } from '../../../../utils/config';
import { createZusInstance } from '../../../../zustand/store';
import { filterTableTranslateKey as TK } from '../mappings/translate';
import { IapiGetAllRes } from '../types';

export interface IsearchParams extends IdateFilter {
  customerNumber: string;
  assetCurrency: string;
  status: string;
  depositRefNo: string;
  targetTransferOrderId: string;
}

type ApiParam = Ipage & Partial<IsearchParams>;

const useZusParams = createZusInstance<ApiParam>(initZusParams);

const useListMapping = (mode: 'export' | 'table') => {
  const { t, tc } = useTranslation('enumConstants');
  const listMappingTransform = useListMappingTransform(mode);

  const listMapping = (array: IapiGetAllRes[], omitKeys: string[] = []) => {
    const res = array.map((item) => {
      const toCreditDisplayAmount = displayAmountCurrying(item.creditCurrencyDecimals);
      const toAssetDisplayAmount = displayAmountCurrying(item.assetCurrencyDecimals);

      const creditAmountDisplayValue = toCreditDisplayAmount(item.creditAmount);
      const assetAmountDisplayValue = toAssetDisplayAmount(item.assetAmount);

      const mapping: Array<[string, IapiGetAllRes | number | string]> = [
        ['rawData', item],
        [TK.referenceNumber, item.depositRefNo],
        [TK.pfhNumber, item.customerNumber],
        [TK.swapType, t(EnumSwapType[item.swapType])],
        [TK.asset, item.assetCurrency],
        [TK.assetAmount, assetAmountDisplayValue],
        [TK.exchangeRate, item.exchangeRate],
        [TK.creditCurrency, item.creditCurrency],
        [TK.creditAmount, creditAmountDisplayValue],
        [TK.status, t(EnumCreditSwapStatus[item.status])],
        [TK.step, t(EnumCreditSwapStep[item.step])],
        [TK.sourceTransferOrderId, item.srcTransferOrderId],
        [TK.targetTransferOrderId, item.targetTransferOrderId],
        [TK.createdBy, item.createdBy],
        [TK.creationTime, toDisplayTime(item.createdDate)],
        [TK.lastModifiedBy, item.lastModifiedBy],
        [TK.lastModifiedTime, toDisplayTime(item.lastModifiedDate)],
      ];

      const mappedResult = mapping.filter(([key]) => !omitKeys.includes(key));
      return mappedResult;
    });

    const output = res.map(listMappingTransform);
    return output;
  };
  return listMapping;
};

export { useZusParams, useListMapping };
